/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreatorDto } from './creator-dto';
import { EnShared } from './en-shared';
import { JoinEntityDto } from './join-entity-dto';
import { MobilityDto } from './mobility-dto';
import { SessionExerciseDto } from './session-exercise-dto';
 /**
 *
 *
 * @export
 * @interface SessionDto
 */
export interface SessionDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof SessionDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof SessionDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof SessionDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof SessionDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof SessionDto
     */
    title: string;

    /**
     * @type {number}
     * @memberof SessionDto
     */
    laps: number;

    /**
     * @type {number}
     * @memberof SessionDto
     */
    rest: number;

    /**
     * @type {MobilityDto}
     * @memberof SessionDto
     */
    mobility?: MobilityDto | null;

    /**
     * @type {boolean}
     * @memberof SessionDto
     */
    isProtocol: boolean;

    /**
     * @type {boolean}
     * @memberof SessionDto
     */
    isTemplate: boolean;

    /**
     * @type {EnShared}
     * @memberof SessionDto
     */
    shared: EnShared;

    /**
     * @type {number}
     * @memberof SessionDto
     */
    duration: number;

    /**
     * @type {string}
     * @memberof SessionDto
     */
    note?: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof SessionDto
     */
    client: JoinEntityDto;

    /**
     * @type {CreatorDto}
     * @memberof SessionDto
     */
    creator: CreatorDto;

    /**
     * @type {Array<SessionExerciseDto>}
     * @memberof SessionDto
     */
    exercises: Array<SessionExerciseDto>;
}
